let backendHost;
const apiVersion = 'v2';


const hostname='rptbeta.bblapp.io'

if(hostname === 'beta.brandedbridgeline.com') {
  backendHost = '//beta.brandedbridgeline.com';
} else if(hostname === 'call6.brandedbridgeline.com') {
  backendHost = '//call6.brandedbridgeline.com';
} else if(hostname === 'reportingsvr.bblapp.io') {
  backendHost = '//reportingsvr.bblapp.io';
} else if(hostname === 'dev.beta.brandedbridgeline.com') {
  backendHost = '//dev.beta.brandedbridgeline.com:8000';
} else if(hostname === 'web.bbl-local-dev.local') {
  backendHost = '//bbl-local-dev.local:8000';
} else if(hostname === 'web.reportingsvr.bblapp.io') {
  backendHost = 'https://rptbeta.bblapp.io';
} else if(/^qa/.test(hostname)) {
  backendHost = `//api.${hostname}`;
} else {
  backendHost = process.env.REACT_APP_BACKEND_HOST || 'https://rptbeta.bblapp.io';
}

console.log('hostname', hostname, 'backendHost', backendHost)
export const API_ROOT = `${backendHost}/api/${apiVersion}`;



// WEBPACK FOOTER //
// ./src/api/apiConfig.js